module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumeShortStyle"
  }, [_c('ul', _vm._l((_vm.jobs), function(job_) {
    return _c('li', {
      key: job_.id
    }, [(job_.job_group_name != null) ? _c('div', {
      staticClass: "jobGroup"
    }, [_c('p', {
      staticClass: "jobGroupName"
    }, [_vm._v(_vm._s(job_.job_group_name))]), _vm._v(" "), _c('p', {
      staticClass: "jobGroupText"
    }, [_vm._v(_vm._s(job_.job_group_text))])]) : _vm._e(), _vm._v(" "), (job_.job_title != null) ? _c('div', {
      staticClass: "job"
    }, [_c('ul', [_c('li', {
      staticClass: "jobHead"
    }, [_c('span', {
      staticClass: "jobTitle",
      domProps: {
        "innerHTML": _vm._s(job_.job_title)
      }
    }, [_vm._v(_vm._s(job_.job_title))]), _vm._v(" "), _c('span', {
      staticClass: "jobTimePeriod"
    }, [_vm._v(_vm._s(job_.job_timePeriod.from) + " – " + _vm._s(job_.job_timePeriod.to))])]), _vm._v(" "), _c('li', {
      staticClass: "jobBody"
    }, [_c('span', [_c('span', {
      staticClass: "jobCompany",
      domProps: {
        "innerHTML": _vm._s(job_.job_company)
      }
    }, [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticClass: "jobLocation"
    }, [_vm._v(_vm._s(job_.job_location))]), _vm._v(" "), (job_.job_url != null) ? _c('span', [_c('a', {
      staticClass: "jobUrl",
      attrs: {
        "href": job_.job_url
      }
    }, [_c('u', [_vm._v(_vm._s(job_.job_url))])])]) : _vm._e()]), _vm._v(" "), _c('span', [(job_.job_ageRange != null) ? _c('span', {
      staticClass: "jobAgeRange"
    }, [_vm._v(_vm._s(job_.job_ageRange))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _vm._l((job_.job_childs), function(job_child) {
      return _c('div', {
        key: job_child.id
      }, [_c('p', [_c('span', {
        staticClass: "jobChild",
        domProps: {
          "innerHTML": _vm._s(job_child.text)
        }
      })])])
    }), _vm._v(" "), _vm._l((job_.skills_groups), function(skills_group) {
      return _c('div', {
        key: skills_group.id,
        staticClass: "skillsGroup"
      }, [(skills_group.skills_group_group_name != null || skills_group.skills_group_group_text != null) ? _c('div', {
        staticClass: "skillsGroupGroup"
      }, [(skills_group.skills_group_group_name != null) ? _c('p', {
        staticClass: "skillsGroupGroupName",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_group_name)
        }
      }) : _vm._e(), _vm._v(" "), (skills_group.skills_group_group_text != null) ? _c('p', {
        staticClass: "skillsGroupGroupText",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_group_text)
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (skills_group.skills_group_name != null) ? _c('div', {
        staticClass: "skillsGroupName"
      }, [(skills_group.skills_group_name != null) ? _c('span', {
        staticClass: "skillsGroupHead",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_name)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [(skills_group.skills_group_timePeriod.from != null) ? _c('span', {
        staticClass: "skillsGroupTimePeriod"
      }, [_vm._v(_vm._s(skills_group.skills_group_timePeriod.from))]) : _vm._e(), _vm._v(" "), (skills_group.skills_group_timePeriod.to != null) ? _c('span', {
        staticClass: "skillsGroupTimePeriod"
      }, [_vm._v(" – " + _vm._s(skills_group.skills_group_timePeriod.to))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "skillsGroupText"
      }, [(skills_group.skills_group_text != null) ? _c('span', {
        staticClass: "skillsGroupBody",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_text)
        }
      }) : _vm._e(), _vm._v(" "), (skills_group.skills_group_ageRange != null) ? _c('span', {
        staticClass: "skillsGroupAgeRange"
      }, [_vm._v(_vm._s(skills_group.skills_group_ageRange))]) : _vm._e()]), _vm._v(" "), _vm._l((skills_group.skills), function(skill_) {
        return _c('div', {
          key: skill_.id,
          staticClass: "skill"
        }, [(skill_.skill_head != null && skill_.skill_link != null) ? _c('div', [_c('div', {
          staticClass: "buttonGroup"
        }, [(skill_.skill_link_tab_index === '0') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '00')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '1') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '01')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '2') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '02')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '3') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '03')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '4') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '04')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '5') ? _c('a', {
          staticClass: "button skillHead",
          attrs: {
            "href": "http://www.eande.world",
            "target": "_blank"
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          }
        }, [_vm._v(":")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "skillBody"
        }, [_vm._v(_vm._s(skill_.skill_body))])], 1)]) : (skill_.skill_head != null && skill_.skill_link == null) ? _c('div', [_c('div', [_c('b', {
          staticClass: "skillHead",
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "skillBody"
        }, [_vm._v(_vm._s(skill_.skill_body))])])]) : _vm._e()])
      })], 2)
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f42e4040"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResumeShort.vue
// module id = 128
// module chunks = 1